module.exports = __webpack_public_path__ + "img/result.c7014468.png";